<template>
  <div class="login">
  </div>
</template>

<script>
import store from '../store/index'
import { getAuthorizeLink } from '../api/authorize'
import {router}  from '../router'
import Vue from 'vue'
import { Dialog,Toast  } from 'vant';

Vue.use(Dialog)

export default {
  components: {
    Dialog
  },
  data() {
    return {
      active: 0
    };
  },
  async mounted(){
    //普通服务器
    let token = store.state.authorize.token || null;
    //如果有Token，不需要重新登录
    if(!token){
      if('development' == process.env.NODE_ENV){
        router.push('/callback?code=123');
        return;
      }
      
      let data = await getAuthorizeLink();
      if(data.code != 200){
        Dialog.alert({
          message: data.message,
        });
        return;
      }

      window.location.href =  data.data
    }
    else
      router.push('/home');
  },
  methods: {
  }
};
</script>
